package com.exura.features.firebase.data.remote.dto.versioning

import com.exura.features.firebase.data.remote.dto.SerializableDto
import com.exura.features.firebase.domain.model.versioning.VersionMetadata
import kotlinx.datetime.LocalDateTime
import kotlinx.serialization.Serializable

@Serializable
data class VersionDto<M: VersionMetadata>(

    val rootVersionId: String,
    val parentVersionId: String?,
    val isActive: Boolean,

    val metadata: M? = null,

    val contentDocPrefix: String,
    val createdAt: LocalDateTime,
) : SerializableDto
